// extracted by css-extract-rspack-plugin
export default {"root":"Footer_root__C6wa4","fullVersionBlock":"Footer_fullVersionBlock__THqxf"};